import React from "react";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import { Avatar } from "@mui/material";

export default function InfoCard({ school }) {
  const color = school.color || "#333";

  return (
    <>
      <Card
        sx={{
          minWidth: "325px",
          borderRadius: "24px",
          backgroundColor: color,
          borderWidth: 0,
        }}
      >
        <CardContent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
              gap: "1.5rem",
            }}
          >
            <div>
              <Avatar
                src={school.logo}
                alt="{school.school} logo"
                sx={{ width: 56, height: 56, mb: 2, backgroundColor: "#FFF" }}
              />
              <Typography level="title-lg" textColor="#FFF">
                {school.school}
              </Typography>
              <Typography level="title-md" textColor="#FEFEFE">
                {school.degree}
              </Typography>
              {school.minor && (
                <div>
                  <Typography level="body-sm" textColor="#EEE">
                    {school.minor}
                  </Typography>
                </div>
              )}
            </div>
            {school.accolade && (
              <div>
                <Typography level="body-md" textColor="#FEFEFE">
                  {school.accolade}
                </Typography>
              </div>
            )}
            <div>
              <Typography level="body-sm" textColor="#FEFEFE">
                {school.dates}
              </Typography>
              <Typography level="title-sm" textColor="#FFF">
                {school.location}
              </Typography>
            </div>
          </div>
        </CardContent>
      </Card>
    </>
  );
}
